import { render } from "./NotFoundView.vue?vue&type=template&id=27603e62&ts=true"
import script from "./NotFoundView.vue?vue&type=script&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__